class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }
  openDrawer() {
    document.dispatchEvent(new Event('open-cart-drawer-after-add-cart'));
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      //send parsed info to drawer cart
      document.dispatchEvent(new CustomEvent('card-drawer__cart-updated', {
        detail: parsedState
      }));
      this.parsedStateResponse = parsedState;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
      if (this.header && this.header.reveal) this.header.reveal();
      // this open method below will open a cart notification when a product is added to it cart-notification
      // this.open();
      this.parsedStateResponse = null;
  }

  getSectionsToRender() {
    const sections = [
      // Is vital that the cart-notification-product stay in the first position.
      {
        id: 'cart-notification-product',
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      }
    ];

    if (this.parsedStateResponse) {
      // if parsedStateResponse has items it means user has added multiple products at time
      if (this.parsedStateResponse.items) {
        const cartNotificationProductSection = sections.shift();
        this.parsedStateResponse.items.forEach(productItem => {
          sections.unshift({
            ...cartNotificationProductSection,
            selector: `#cart-notification-product-${productItem.id}`,
          })
        })
      } else {
        // user has add one single product at time
        if (sections[0].id === 'cart-notification-product') {
          sections[0] = {
            ...sections[0],
            selector: `#cart-notification-product-${this.parsedStateResponse.id}`,
          }
        }
      }
    }
 
    return sections
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
